export enum RugbyLeagueStatId {
  Tries = 400,
  DropGoals = 401,
  Conversions = 402,
  YellowCards = 8,
  RedCards = 9,
  PenaltyGoals = 121,
  PointsScored = 595,
  TacklesMade = 1676,
  Offloads = 1658,
  LineOuts = 1671,
  Scrums = 1667,
  TurnoversWon = 72,
  GreenCards = 1807,
  DropGoalsMissed = 1652,
  TackleBreaks = 1808,
  /** TODO: check later if it's correct */
  ScrumsEfficiency = 1670,
  /** TODO: update this later with proper id */
  Substitution = 9998,
  /** TODO: update this later with proper id - Effective tackle % */
  EffectiveTacklePercentage = 9997,
  /** TODO: update this later with proper id - Drop goals % */
  DropGoalsPercentage = 9996,
}
